var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404 flex-col justify-align-center"},[_c('Nav'),_c('img',{staticClass:"img-404",attrs:{"src":require("../../assets/img/404.png"),"alt":"可搭吖"}}),_c('span',{staticClass:"txt-404"},[_vm._v("哎呀，打不开网页了呢")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }